// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"styles_subtitle__2bd5Y","buttons":"styles_buttons__1UpXL"};